import imageUpload1 from 'assets/Images/image_uploader_layout_1.svg'
import imageUpload2 from 'assets/Images/image_uploader_layout_2.svg'
import imageUpload3 from 'assets/Images/image_uploader_layout_3.svg'
import imageUpload4 from 'assets/Images/image_uploader_layout_4.svg'
import imageUpload5 from 'assets/Images/image_uploader_layout_5.svg'
import imageUpload6 from 'assets/Images/image_uploader_layout_6.svg'
import imageUpload7 from 'assets/Images/image_uploader_layout_7.svg'
import imageUpload8 from 'assets/Images/image_uploader_layout_8.svg'
import imageUpload9 from 'assets/Images/image_uploader_layout_9.svg'
import hero1 from 'assets/Images/hero_1_layout.svg'
import hero2 from 'assets/Images/hero_2_layout.svg'
import hero3 from 'assets/Images/hero_3_layout.svg'
import hero4 from 'assets/Images/hero_4_layout.svg'
import hero5 from 'assets/Images/hero_5_layout.svg'
import hero6 from 'assets/Images/hero_6_layout.svg'
import hero7 from 'assets/Images/hero_7_layout.svg'
import hero8 from 'assets/Images/hero_8_layout.svg'
import hero9 from 'assets/Images/hero_9_layout.svg'

export const staticImgsEditor = [
  imageUpload1,
  imageUpload2,
  imageUpload3,
  imageUpload4,
  imageUpload5,
  imageUpload6,
  imageUpload7,
  imageUpload8,
  imageUpload9,
]
export const staticImgsWebPreview = [
  hero1,
  hero2,
  hero3,
  hero4,
  hero5,
  hero6,
  hero7,
  hero8,
  hero9,
]
